export default [
  {
    header: 'navbars.sms_sending',
    permission: ['user_management'],
    unique_name: 'sms-templates',
  },
  {
    title: 'navbars.sms_templates',
    route: 'sms-templates',
    icon: 'MailIcon',
    permission: ['user_management'],
    unique_name: 'sms-templates',
  },
  {
    title: 'navbars.manual_dispatch',
    route: 'sms-sending',
    icon: 'SendIcon',
    permission: ['user_management'],
    unique_name: 'sms-sending',
  },
  {
    title: 'navbars.auto_send',
    route: 'auto-sms',
    icon: 'FastForwardIcon',
    permission: ['user_management'],
    unique_name: 'auto-sms',
  },
]